import { IPhones } from "interfaces/IContact/IPhones";

export const hasPhone = (phones: IPhones | undefined) => {
  if (!phones) return;
  const { mobile, home, businessFax, businessPhone } = phones;
  const hasPhone = mobile ?? home ?? businessPhone ?? businessFax;
  return !!hasPhone;
};
